import axios from 'utils/requestHelper';

const fetchAll = (params) => axios.get('v1/clients/brands', { params });

const BrandAPI = {
  fetchAll,
};

export default BrandAPI;
